export default __webpack_public_path__ + "static/media/@missed_win.439725e7.svg";